import React from 'react';
import { Image } from '../styles/title-image.style';
/**
 * Video Hero Component
 * @returns {XML} Hero Component
 */
const TitleImage = ({ src, alt }) => (
  <Image src={src} alt={alt} />
);

export default TitleImage;



// WEBPACK FOOTER //
// ./src/components/title-image/components/title-image.js